import type { ReactElement } from "react"

import { ErrorPage } from "@/components/global/Errors/ErrorPage"

export function UnavailablePage(): ReactElement {
  return (
    <ErrorPage
      title="OneSchema is under maintenance"
      subtitle="We're performing scheduled maintenance and will be back shortly. Please try again in a few minutes."
      returnUrl=""
      returnText=""
    />
  )
}
